<script>
import Layout from "../../layouts/main";
//import appConfig from "@/app.config";
import config from "../../../config/config";
import { mapActions } from "vuex";
import tinymce from "vue-tinymce-editor";
import { error_message, success_message } from "../../../state/helpers";
import { required } from "vuelidate/lib/validators";

/**
 * Starter component
 */
export default {
  components: { tinymce, Layout },
  data() {
    return {
      config: config,
      typeform: {
        page_name: "",
        page_title: "",
        page_content: "",
      },
      plugins: [
        // "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 300,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },
    };
  },
  validations: {
    typeform: {
      page_name: {
        required,
      },
      page_title: {
        required,
      },
      page_content: {
        required,
      },
    },
  },
  methods: {
    ...mapActions("page", ["addPage"]),
    addContentPage() {
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      } else {
        this.addPage(this.typeform).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.msg);
            this.$router.push({ name: "content-page-list" });
          } else {
            error_message(response.data.msg);
          }
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon d-flex">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bx-briefcase"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">Add Content Page</h4>
              <p>
                <router-link :to="{ name: 'content-page-list' }"
                  >Content Pages</router-link
                >
                > Add Content Page
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form @submit.prevent="addContentPage">
          <div class="card">
            <div class="card-body">
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">Page Name</label>
                    <input
                      id="page_name"
                      v-model="$v.typeform.page_name.$model"
                      type="text"
                      class="form-control"
                      placeholder="Page Name"
                      name="page_name"
                      :class="{ 'is-invalid': $v.typeform.page_name.$error }"
                    />
                    <div v-if="$v.typeform.page_name.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.page_name.required"
                        >Please Enter Page Name</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">Page Title</label>
                    <input
                      id="page_title"
                      v-model="$v.typeform.page_title.$model"
                      type="text"
                      class="form-control"
                      placeholder="Page Title"
                      name="page_title"
                      :class="{ 'is-invalid': $v.typeform.page_title.$error }"
                    />
                    <div v-if="$v.typeform.page_title.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.page_title.required"
                        >Please Enter Page Title</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="required">Page Content</label>
                    <tinymce
                      id="d1"
                      v-model="$v.typeform.page_content.$model"
                      :plugins="plugins"
                      :toolbar="toolbar"
                      :other_options="options"
                      :class="{ 'is-invalid': $v.typeform.page_content.$error }"
                    >
                    </tinymce>
                    <div v-if="$v.typeform.page_content.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.page_content.required"
                        >Please Enter Page Content</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <button class="btn btn-primary mr-1 mt-3">Add Content Page</button>
                  <b-button
                    @click="$router.go(-1)"
                    type="button"
                    variant="secondary"
                    class="mt-3"
                    >Cancel</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
